<template>
  <div>
    <p v-if="showTitle" class="title">CPU</p>
    <vue-c3 :handler="chart"></vue-c3>
  </div>
</template>

<script>
import Vue from "vue";
import VueC3 from "vue-c3";

export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      current_results: {
        user: 0,
        nice: 0,
        system: 0,
        idle: 0,
        iowait: 0,
        irq: 0,
        softirq: 0,
        steal: 0,
        guest: 0,
        guest_nice: 0
      },
      last_results: {
        user: 0,
        nice: 0,
        system: 0,
        idle: 0,
        iowait: 0,
        irq: 0,
        softirq: 0,
        steal: 0,
        guest: 0,
        guest_nice: 0
      },
      cpuUsage: 0,
      chart: new Vue()
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  mounted() {
    this.initGraph();
  },
  methods: {
    startMonitor() {
      this.$http
        .get(this.serverUrl + "cpu.php")
        .then(response => {
          this.current_results = response.data;

          let last_idle = this.last_results.idle + this.last_results.iowait;
          let idle = this.current_results.idle + this.current_results.iowait;

          let last_non_idle =
            this.last_results.user +
            this.last_results.nice +
            this.last_results.system +
            this.last_results.irq +
            this.last_results.steal;
          let non_idle =
            this.current_results.user +
            this.current_results.nice +
            this.current_results.system +
            this.current_results.irq +
            this.current_results.steal;

          let last_total = last_idle + last_non_idle;
          let total = idle + non_idle;

          let totald = total - last_total;
          let idled = idle - last_idle;

          let currentCpuUsage = Math.round((totald - idled) / totald * 100);

          this.last_results = response.data;

          if (this.cpuUsage != currentCpuUsage) {
            this.cpuUsage = currentCpuUsage;
            this.updateGraph();
            this.$emit("valueChanged", this.cpuUsage + "%");
          }

          setTimeout(() => {
            this.startMonitor();
          }, 3000);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    },
    initGraph() {
      const options = {
        data: {
          type: "gauge",
          columns: [["usage", 0]]
        },
        color: {
          pattern: ["#3daee9", "#fdbc4b", "#c0392b"],
          threshold: {
            values: [40, 90, 100]
          }
        },
        tooltip: {
          show: false
        },
        legend: {
          hide: true
        }
      };
      this.chart.$emit("init", options);
    },
    updateGraph() {
      const options = {
        columns: [["usage", this.cpuUsage]]
      };
      this.chart.$emit("dispatch", chart => chart.load(options));
    }
  },
  components: {
    VueC3
  }
};
</script>

<style scoped>
body {
color: #F6C600
}
</style>



// WEBPACK FOOTER //
// app/monitor/src/components/MonitorCpu.vue